import React from 'react';
import { connect } from "react-redux";
import loadingLogo from './../images/billy-logo.png'
import loadingLogoDark from './../images/Billy-Logo-White.png'

export class Loader extends React.Component{
    render(){
        let logo = this.props.darkTheme? loadingLogoDark : loadingLogo
        return( 
            <div className="lds-dual-ring">
                <img 
                    className="menu-icon animate-flicker" 
                    alt="logo" 
                    src={logo} 
                    height="50" 
                    style={{width: "100px"}}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        asideColapsed: state.user.asideColapsed,
        darkTheme: state.user.darkTheme
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Loader);